import React from 'react';
import proptypes from 'prop-types';
import { params, string } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { EXPECTED_DELIVERY_DATE } from '../constants/index';
import { CustomSkeletonLine } from './subcomponents/CustomSkeletonLine';
import useGetPlaceholderHeight from '../hooks/useGetPlaceholderHeight';

const { string: stringType, shape: shapeType, bool: boolType, arrayOf: arrayOfType } = proptypes;

const BundleDeliveryDate = ({
  product, loading, bundleDeliveryDate, checkAvailabilityDeliveryDate, deliveryDateLoading, products
}) => {

  const shouldShowBundleDeliveryDate = useConfigService('fs:showBundleDeliveryDate') || null;
  const { deliveryDatePlaceholderHeight } = useGetPlaceholderHeight(product);
  const { getAvailability } = product?.features || {};
  const deliveryDate = checkAvailabilityDeliveryDate || bundleDeliveryDate;
  const hasActiveProducts = products?.some((bundleProduct) => !bundleProduct?.removed);
  const shouldShowDateRow = Boolean(hasActiveProducts && deliveryDate);

  if (!shouldShowBundleDeliveryDate || !getAvailability || !deliveryDate) {
    return null;
  }

  if ((loading || deliveryDateLoading) && shouldShowDateRow) {
    return <CustomSkeletonLine height={deliveryDatePlaceholderHeight} />;
  }

  return (
    <div data-component="BundleDeliveryDate">
      {shouldShowDateRow && (
        <div className="sui-flex">
          <Typography variant="body-lg">Available by&nbsp;</Typography>
          <Typography variant="body-lg" weight="bold">{`${deliveryDate}`}</Typography>
        </div>
      )}
      <Typography variant="body-sm">{EXPECTED_DELIVERY_DATE}</Typography>
    </div>
  );
};

BundleDeliveryDate.propTypes = {
  product: shapeType({
    bundleSpecificationDetails: shapeType({
      deliveryDate: stringType
    })
  }).isRequired,
  loading: boolType.isRequired,
  bundleDeliveryDate: stringType,
  checkAvailabilityDeliveryDate: stringType,
  deliveryDateLoading: boolType,
  products: arrayOfType(shapeType({
    removed: boolType
  }))
};

BundleDeliveryDate.defaultProps = {
  bundleDeliveryDate: null,
  checkAvailabilityDeliveryDate: null,
  deliveryDateLoading: false,
  products: []
};

BundleDeliveryDate.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    bundleSpecificationDetails: params({ storeId: string(), zipCode: string() }).shape({
      deliveryDate: string()
    })
  })
};

BundleDeliveryDate.displayName = 'BundleDeliveryDate';

export { BundleDeliveryDate };